import { Button } from '@material-ui/core';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import clsx from 'clsx';
import { FC } from 'react';
import { EDIT_PROFILE_TITLE } from '../constants';
import { useStyles } from '../styles';
import { displayOrMissing, formatBirthDate, formatLanguage, formatPhone } from '../utils';
import ProfileEditForm from './ProfileEditForm';

interface ProfileTabProps {
  user: any;
  editing: boolean;
  onStartEdit: () => void;
  onUserUpdated: (updated?: any) => Promise<void> | void;
  onEditingChange?: (editing: boolean) => void;
}

const ProfileTab: FC<ProfileTabProps> = ({
  user,
  editing,
  onStartEdit,
  onUserUpdated,
  onEditingChange,
}) => {
  const classes = useStyles();
  const firstname = displayOrMissing(user?.firstname);
  const lastname = displayOrMissing(user?.lastname);
  const birthDate = displayOrMissing(formatBirthDate(user?.dayOfBirth));
  const gender = displayOrMissing(user?.gender);
  const postal = displayOrMissing(user?.postal_code);
  const town = displayOrMissing(user?.town);
  const language = displayOrMissing(formatLanguage(user?.language));
  const diploma = displayOrMissing(user?.diploma);
  const email = displayOrMissing(user?.email);
  const phone = formatPhone(user?.phone);

  const handleSaved = async (updated?: any) => {
    await onUserUpdated(updated);
    onEditingChange?.(false);
  };

  const renderValue = (item: { text: string; missing: boolean }) => (
    <span className={clsx(classes.fieldValue, item.missing && classes.missing)}>{item.text}</span>
  );

  if (editing) {
    return (
      <div className={classes.card}>
        <h1 className={classes.editPageTitle}>{EDIT_PROFILE_TITLE}</h1>
        <ProfileEditForm
          user={user}
          onSaved={handleSaved}
          onCancel={() => onEditingChange?.(false)}
        />
      </div>
    );
  }

  return (
    <div className={classes.card}>
      <Button
        className={classes.editBtn}
        startIcon={<PencilSimpleIcon size={18} />}
        onClick={onStartEdit}>
        Éditer
      </Button>
      <div className={classes.fields}>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Prénom :</span>
          {renderValue(firstname)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Nom :</span>
          {renderValue(lastname)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Date de naissance :</span>
          {renderValue(birthDate)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Sexe :</span>
          {renderValue(gender)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Code Postal :</span>
          {renderValue(postal)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Ville :</span>
          {renderValue(town)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Téléphone :</span>
          {phone ? (
            <span className={classes.phoneValue}>
              {phone.country ? (
                <img
                  className={classes.flag}
                  src={`https://flagcdn.com/w40/${phone.country.toLowerCase()}.png`}
                  alt=""
                />
              ) : null}
              <span className={classes.fieldValue}>{phone.display}</span>
            </span>
          ) : (
            renderValue(displayOrMissing(null))
          )}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Langue :</span>
          {renderValue(language)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Diplôme :</span>
          {renderValue(diploma)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Mail :</span>
          {renderValue(email)}
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;
